import usePrivateAxios from '@/common/api/usePrivateAxios';
import { useQuery } from '@tanstack/react-query';
import { DashboardComponentData, DashboardComponentFiltersParamsParsed, DashboardComponentResponse } from '../../types/dashboards/dashboardComponent.type';

type UseDashboardComponentsPreviewProps = {
  filters?: {
    generatorKlass?: string;
    kind?: string;
    filters?: DashboardComponentFiltersParamsParsed;
  };
}

export const useDashboardComponentsPreview = ({
  filters: { generatorKlass, kind, filters = {} } = {},
}: UseDashboardComponentsPreviewProps) => {
  const privateAxios = usePrivateAxios();

  return useQuery<DashboardComponentResponse, unknown, DashboardComponentData>({
    enabled: !!generatorKlass,
    queryKey: [
      'dashboardComponentPreview',
      generatorKlass,
      kind,
      ...[filters ?? {}],
    ],
    queryFn: () => privateAxios.get(`/dashboard_components/preview`, {
      params: {
        generator_klass: generatorKlass,
        kind,
        q: {
          ...filters,
        }
      },
    }),
    select: (data) => data?.data?.data,
  });
}
